import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer, { restoreSession } from './slices/authSlice';
import vendorReducer from './slices/vendorSlice';
import formReducer from './slices/formSlice';
import documentsReducer from './slices/documentsSlice';
import entityReducer from './slices/entitySlice';
import verificationReducer from './slices/verificationSlice';
import consentReducer from './slices/consentSlice';
import photoReducer from './slices/photoSlice';

// Combine all reducers
const rootReducer = combineReducers({
  auth: authReducer,
  vendor: vendorReducer,
  form: formReducer,
  documents: documentsReducer,
  entity: entityReducer,
  verification: verificationReducer,
  consent: consentReducer,
  photo: photoReducer,
});

// Configure store
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for File objects in documents slice
        ignoredActions: ['documents/addUpload'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.file'],
        // Ignore these paths in the state
        ignoredPaths: ['documents.uploads'],
      },
    }),
  devTools: !import.meta.env.PROD,
});

// Restore session on app load
store.dispatch(restoreSession());

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
